<template>
  <b-dropdown variant="outline-primary" class="m-md-2" toggle-class="btn--has-icon">
    <template v-slot:button-content>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23 .5a.5.5 0 0 1 .5.5v5.5H.5V1A.5.5 0 0 1 1 .5h22zm-14.5 23v-16h7v16h-7zm8 0v-16h7V23a.5.5 0 0 1-.5.5h-6.5zM.5 23V7.5h7v16H1a.5.5 0 0 1-.5-.5z"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </svg>
    </template>
    <b-dropdown-header id="dropdown-header-label">
      <strong>{{ $t("lang.label_certificate_showColumns") }}</strong>
    </b-dropdown-header>

    <b-dropdown-form form-class="p-0">
      <b-form-group class="dropdown-item bg-white text-body">
        <b-form-checkbox v-for="column in columnsOptions" v-model="selected" :key="column.value" :value="column.value" stacked>
          {{ $t("lang.label_certificate_" + column.value) }}
        </b-form-checkbox>
      </b-form-group>
    </b-dropdown-form>
  </b-dropdown>
</template>
<script>
export default {
  name: "CertificateDatatableColumnsDropdown",
  props: {
    // Support v-model via this.selected
    value: {
      // e.g. ["certStatus", "serialNumber", "issuerDn", "subjectDn"]
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columnsOptions: [
        { value: "subjectDn" },
        { value: "issuerDn" },
        { value: "serialNumber" },
        { value: "certPublicKeyAlgorithm" },
        { value: "certSignatureAlgorithm" },
        { value: "certUsageType" },
        { value: "validNotBefore" },
        { value: "validNotAfter" },
        { value: "certStatus" }
      ]
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods: {}
};
</script>
